module.exports = __webpack_public_path__ + "img/fr.bc9e0707.png";